// CollectionHero.jsx
import React from 'react';
import styles from './Customer-Support.module.css';

function CollectionHero() {
  return (
    <>
      {/* === HERO SECTION === */}
      <div className={styles.heroContainer}>
        {/* BADGE */}
        <div className={styles.badge}>AI Customer Support</div>

        {/* HEADLINE */}
        <h1 className={styles.headline}>
          Customer Support That <br />
          <span className={styles.highlight}>Exceeds Expectations</span>
        </h1>

        {/* SUBTITLE */}
        <p className={styles.subtitle}>
          Deliver exceptional customer experiences with AI-powered support that's available
          24/7, understands context, and resolves issues in seconds—not hours.
        </p>

        {/* CTA BUTTONS */}
        <div className={styles.ctaButtons}>
          <button className={styles.primaryBtn}>Start Free Trial</button>
          <button className={styles.secondaryBtn}>Watch Demo</button>
        </div>

        {/* STATS SECTION */}
        <div className={styles.statsContainer}>
          <div className={styles.statCard}>
            <h2 className={styles.statNumber}>50%</h2>
            <p className={styles.statLabel}>Reduction in Support Costs</p>
          </div>
          <div className={styles.statCard}>
            <h2 className={styles.statNumber}>&lt;30%</h2>
            <p className={styles.statLabel}>Response Time</p>
          </div>
          <div className={styles.statCard}>
            <h2 className={styles.statNumber}>90%</h2>
            <p className={styles.statLabel}>Customer Satisfaction</p>
          </div>
          <div className={styles.statCard}>
            <h2 className={styles.statNumber}>4.8★</h2>
            <p className={styles.statLabel}>Average Rating</p>
          </div>
        </div>
      </div>

      {/* === YOUR ALL-IN-ONE AI HQ SECTION === */}
      <div className={styles.aihqContainer}>
        <h2 className={styles.aihqHeading}>Your All-in-One AI HQ</h2>
        <p className={styles.aihqSubheading}>
          Everything you need to deliver world-class customer support in one powerful platform
        </p>

        <div className={styles.aihqFeatures}>
          {/* Feature 1 */}
          <div className={styles.featureCard}>
            <div className={styles.checkIcon}>
              <svg width="42" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="8" fill="#F5EEFF"/>
                <path d="M9 12L11 14L15 10" stroke="#8A3FFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className={styles.featureTitle}>Instant Answers</h3>
            <p className={styles.featureDesc}>
              AI-powered responses that understand context and provide accurate solutions instantly
            </p>
          </div>

          {/* Feature 2 */}
          <div className={styles.featureCard}>
            <div className={styles.checkIcon}>
              <svg width="42" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="8" fill="#F5EEFF"/>
                <path d="M9 12L11 14L15 10" stroke="#8A3FFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className={styles.featureTitle}>Smart Routing</h3>
            <p className={styles.featureDesc}>
              Automatically route complex queries to the right team member with full context
            </p>
          </div>

          {/* Feature 3 */}
          <div className={styles.featureCard}>
            <div className={styles.checkIcon}>
              <svg width="42" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="8" fill="#F5EEFF"/>
                <path d="M9 12L11 14L15 10" stroke="#8A3FFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className={styles.featureTitle}>Unified Dashboard</h3>
            <p className={styles.featureDesc}>
              Manage all customer interactions from a single, intuitive interface
            </p>
          </div>
        </div>
      </div>

            {/* === AI TRIGGERS FOR EVERY SCENARIO === */}
      <div className={styles.triggersContainer}>
        <h2 className={styles.triggersHeading}>AI Triggers for every Scenario</h2>
        <p className={styles.triggersSubheading}>
          Automate responses based on customer behavior, intent, and context
        </p>

        <div className={styles.triggersGrid}>
          {/* Card 1 */}
          <div className={styles.triggerCard}>
            <h3 className={styles.triggerTitle}>New User Onboarding</h3>
            <p className={styles.triggerDesc}>
              Automated AI responses tailored to customer needs
            </p>
          </div>

          {/* Card 2 */}
          <div className={styles.triggerCard}>
            <h3 className={styles.triggerTitle}>Billing Inquiries</h3>
            <p className={styles.triggerDesc}>
              Automated AI responses tailored to customer needs
            </p>
          </div>

          {/* Card 3 */}
          <div className={styles.triggerCard}>
            <h3 className={styles.triggerTitle}>Technical Issues</h3>
            <p className={styles.triggerDesc}>
              Automated AI responses tailored to customer needs
            </p>
          </div>

          {/* Card 4 */}
          <div className={styles.triggerCard}>
            <h3 className={styles.triggerTitle}>Feature Requests</h3>
            <p className={styles.triggerDesc}>
              Automated AI responses tailored to customer needs
            </p>
          </div>

          {/* Card 5 */}
          <div className={styles.triggerCard}>
            <h3 className={styles.triggerTitle}>Cancellation Prevention</h3>
            <p className={styles.triggerDesc}>
              Automated AI responses tailored to customer needs
            </p>
          </div>

          {/* Card 6 */}
          <div className={styles.triggerCard}>
            <h3 className={styles.triggerTitle}>Product Updates</h3>
            <p className={styles.triggerDesc}>
              Automated AI responses tailored to customer needs
            </p>
          </div>
        </div>
      </div>

            {/* === WHY AI-POWERED SUPPORT WINS === */}
      <div className={styles.winsContainer}>
        <h2 className={styles.winsHeading}>Why AI-Powered Support Wins</h2>

        <div className={styles.winsGrid}>
          {/* Card 1: 24/7 Availability */}
          <div className={styles.winsCard}>
            <h3 className={styles.winsTitle}>24/7 Availability</h3>
            <p className={styles.winsDesc}>
              Never miss a customer query. Provide instant support around the clock, across all time zones.
            </p>
            <ul className={styles.winsBullets}>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> Instant responses</li>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> No wait times</li>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> Global coverage</li>
            </ul>
          </div>

          {/* Card 2: Scalable Solution */}
          <div className={styles.winsCard}>
            <h3 className={styles.winsTitle}>Scalable Solution</h3>
            <p className={styles.winsDesc}>
              Handle thousands of conversations simultaneously without adding headcount or costs.
            </p>
            <ul className={styles.winsBullets}>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> Unlimited conversations</li>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> No hiring needed</li>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> Cost efficient</li>
            </ul>
          </div>

          {/* Card 3: Smart & Learning */}
          <div className={styles.winsCard}>
            <h3 className={styles.winsTitle}>Smart & Learning</h3>
            <p className={styles.winsDesc}>
              Continuously improves with every interaction, learning from your best support practices.
            </p>
            <ul className={styles.winsBullets}>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> Self-improving AI</li>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> Pattern recognition</li>
              <li className={styles.winsBullet}><span className={styles.checkMark}>✓</span> Context awareness</li>
            </ul>
          </div>
        </div>
      </div>

            {/* === FRICTIONLESS AI-POWERED SUPPORT === */}
      <div className={styles.frictionlessContainer}>
        <h2 className={styles.frictionlessHeading}>Frictionless AI-Powered Support</h2>
        <p className={styles.frictionlessSubheading}>
          Seamlessly integrate with your existing tools and workflows
        </p>

        <div className={styles.integrationsGrid}>
          {/* Card 1 */}
          <div className={styles.integrationCard}>
            <h3 className={styles.integrationTitle}>Email Integration</h3>
            <p className={styles.integrationDesc}>Connect your support email</p>
          </div>

          {/* Card 2 */}
          <div className={styles.integrationCard}>
            <h3 className={styles.integrationTitle}>Live Chat</h3>
            <p className={styles.integrationDesc}>Widget for your website</p>
          </div>

          {/* Card 3 */}
          <div className={styles.integrationCard}>
            <h3 className={styles.integrationTitle}>Slack Connect</h3>
            <p className={styles.integrationDesc}>Support via Slack channels</p>
          </div>

          {/* Card 4 */}
          <div className={styles.integrationCard}>
            <h3 className={styles.integrationTitle}>API Access</h3>
            <p className={styles.integrationDesc}>Custom integrations</p>
          </div>
        </div>
      </div>

            {/* === USE AI SUPPORT COPILOT === */}
      <div className={styles.copilotContainer}>
        <h2 className={styles.copilotHeading}>Use AI Support Copilot</h2>
        <p className={styles.copilotSubheading}>
          Empower your support team with AI assistance that suggests responses, finds relevant information, and helps resolve issues faster
        </p>

        <div className={styles.copilotGrid}>
          {/* Left Column: Suggested Responses */}
          <div className={styles.copilotColumn}>
            <h3 className={styles.copilotTitle}>Suggested Responses</h3>
            <p className={styles.copilotDesc}>
              AI analyzes the conversation and suggests the best responses based on your knowledge base and past successful resolutions.
            </p>
            <ul className={styles.copilotBullets}>
              <li className={styles.copilotBullet}><span className={styles.checkMark}>✓</span> Context-aware suggestions</li>
              <li className={styles.copilotBullet}><span className={styles.checkMark}>✓</span> One-click responses</li>
              <li className={styles.copilotBullet}><span className={styles.checkMark}>✓</span> Customizable templates</li>
            </ul>
          </div>

          {/* Right Column: Knowledge Base Search */}
          <div className={styles.copilotColumn}>
            <h3 className={styles.copilotTitle}>Knowledge Base Search</h3>
            <p className={styles.copilotDesc}>
              Instantly find relevant articles, documentation, and solutions from your entire knowledge base without leaving the conversation.
            </p>
            <ul className={styles.copilotBullets}>
              <li className={styles.copilotBullet}><span className={styles.checkMark}>✓</span> Semantic search</li>
              <li className={styles.copilotBullet}><span className={styles.checkMark}>✓</span> Auto-populated answers</li>
              <li className={styles.copilotBullet}><span className={styles.checkMark}>✓</span> Smart recommendations</li>
            </ul>
          </div>
        </div>
      </div>

            {/* === ENTERPRISE SUPPORT PARTNERS === */}
      <div className={styles.partnersContainer}>
        <h2 className={styles.partnersHeading}>Enterprise Support Partners</h2>

        <div className={styles.partnersGrid}>
          {/* Left Card: Dedicated Success Manager */}
          <div className={styles.partnerCard}>
            <h3 className={styles.partnerTitle}>Dedicated Success Manager</h3>
            <p className={styles.partnerDesc}>
              Get a dedicated point of contact who understands your business and ensures your success.
            </p>
            <ul className={styles.partnerBullets}>
              <li className={styles.partnerBullet}><span className={styles.checkMark}>✓</span> Onboarding assistance</li>
              <li className={styles.partnerBullet}><span className={styles.checkMark}>✓</span> Regular strategy reviews</li>
              <li className={styles.partnerBullet}><span className={styles.checkMark}>✓</span> Custom training sessions</li>
              <li className={styles.partnerBullet}><span className={styles.checkMark}>✓</span> Priority support access</li>
            </ul>
          </div>

          {/* Right Card: Custom Development */}
          <div className={styles.partnerCard}>
            <h3 className={styles.partnerTitle}>Custom Development</h3>
            <p className={styles.partnerDesc}>
              Need something specific? Our team can build custom features and integrations for your needs.
            </p>
            <ul className={styles.partnerBullets}>
              <li className={styles.partnerBullet}><span className={styles.checkMark}>✓</span> Tailored AI training</li>
              <li className={styles.partnerBullet}><span className={styles.checkMark}>✓</span> Custom integrations</li>
              <li className={styles.partnerBullet}><span className={styles.checkMark}>✓</span> White-label options</li>
              <li className={styles.partnerBullet}><span className={styles.checkMark}>✓</span> API customization</li>
            </ul>
          </div>
        </div>
      </div>

            {/* === FROM STARTUP TO SCALE IN WEEKS === */}
      <div className={styles.scaleContainer}>
        <h2 className={styles.scaleHeading}>From Startup to Scale in Weeks</h2>

        <div className={styles.stepsGrid}>
          {/* Step 1 */}
          <div className={styles.stepCard}>
            <div className={styles.stepNumber}>1</div>
            <h3 className={styles.stepTitle}>Quick Setup</h3>
            <p className={styles.stepDesc}>
              Connect your tools and import your knowledge base in minutes. No technical expertise required.
            </p>
          </div>

          {/* Step 2 */}
          <div className={styles.stepCard}>
            <div className={styles.stepNumber}>2</div>
            <h3 className={styles.stepTitle}>Train Your AI</h3>
            <p className={styles.stepDesc}>
              Our AI learns from your data, best practices, and brand voice to deliver personalized support.
            </p>
          </div>

          {/* Step 3 */}
          <div className={styles.stepCard}>
            <div className={styles.stepNumber}>3</div>
            <h3 className={styles.stepTitle}>Go Live</h3>
            <p className={styles.stepDesc}>
              Launch your AI support in days, not months. Start delighting customers immediately.
            </p>
          </div>
        </div>
      </div>

            {/* === VOICE AND MESSAGING AGENT === */}
      <div className={styles.voiceContainer}>
        <h2 className={styles.voiceHeading}>Voice and Messaging agent</h2>
        <p className={styles.voiceSubheading}>
          Support customers where they are—via phone, SMS, WhatsApp, and more
        </p>

        <div className={styles.voiceGrid}>
          {/* Left Card: Voice Support */}
          <div className={styles.voiceCard}>
            <h3 className={styles.voiceTitle}>Voice Support</h3>
            <p className={styles.voiceDesc}>
              Natural-sounding AI voice agents that handle calls professionally and route to humans when needed.
            </p>
            <ul className={styles.voiceBullets}>
              <li className={styles.voiceBullet}><span className={styles.whiteCheck}>✓</span> Natural conversations</li>
              <li className={styles.voiceBullet}><span className={styles.whiteCheck}>✓</span> Multi-language support</li>
              <li className={styles.voiceBullet}><span className={styles.whiteCheck}>✓</span> Smart call routing</li>
            </ul>
          </div>

          {/* Right Card: Messaging Channels */}
          <div className={styles.voiceCard}>
            <h3 className={styles.voiceTitle}>Messaging Channels</h3>
            <p className={styles.voiceDesc}>
              Meet customers on their preferred messaging platforms with consistent, intelligent responses.
            </p>
            <ul className={styles.voiceBullets}>
              <li className={styles.voiceBullet}><span className={styles.whiteCheck}>✓</span> WhatsApp integration</li>
              <li className={styles.voiceBullet}><span className={styles.whiteCheck}>✓</span> SMS support</li>
              <li className={styles.voiceBullet}><span className={styles.whiteCheck}>✓</span> Social media messaging</li>
            </ul>
          </div>
        </div>
      </div>

            {/* === STILL HAVE QUESTIONS? (FAQ ACCORDION) === */}
      <div className={styles.faqContainer}>
        <h2 className={styles.faqHeading}>Still have Questions?</h2>

        <div className={styles.faqList}>
          {[
            { q: "How quickly can I get started?", a: "You can connect your tools and import your knowledge base in under 10 minutes — no technical expertise required." },
            { q: "Do I need technical knowledge?", a: "No. Our platform is designed for non-technical teams. Setup is intuitive, and our success managers guide you every step." },
            { q: "Can I customize the AI responses?", a: "Yes. Use customizable templates, brand voice tuning, and fine-tune responses based on your knowledge base and past resolutions." },
            { q: "What happens to complex queries?", a: "AI intelligently routes complex or high-risk queries to human agents — with full context preserved — ensuring seamless handoff." },
            { q: "Is my data secure?", a: "Absolutely. We comply with GDPR, SOC 2, and encrypt all data in transit and at rest. Your data never trains third-party models." },
          ].map((item, index) => (
            <div key={index} className={styles.faqItem}>
              <button
                className={styles.faqQuestion}
                aria-expanded={false}
                aria-controls={`faq-answer-${index}`}
              >
                <span>{item.q}</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.chevron}>
                  <path d="M9 5L16 12L9 19" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              {/* Optional: expandable answer (hidden by default) */}
              <div id={`faq-answer-${index}`} className={styles.faqAnswer}>
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>

        <button className={styles.faqCtaButton}>
          Contact Sales
        </button>
      </div>

            {/* === FINAL CTA: READY TO TRANSFORM? === */}
      <div className={styles.ctaContainer}>
        <h2 className={styles.ctaHeading}>Ready to Transform Your Customer Support?</h2>
        <p className={styles.ctaSubheading}>
          Join thousands of companies delivering exceptional support with ToxBox.AI
        </p>
        <button className={styles.ctaButton}>
          Start Free Trial →
        </button>
      </div>

    </>
  );
}

export default CollectionHero;